var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchiveProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 22.7502H7.5C4.2 22.7502 3.75 20.9502 3.75 19.0002V10.2202C3.75 9.81021 4.09 9.47021 4.5 9.47021C4.91 9.47021 5.25 9.81021 5.25 10.2202V19.0002C5.25 20.7402 5.55 21.2502 7.5 21.2502H16.5C18.45 21.2502 18.75 20.7402 18.75 19.0002V10.2202C18.75 9.81021 19.09 9.47021 19.5 9.47021C19.91 9.47021 20.25 9.81021 20.25 10.2202V19.0002C20.25 20.9502 19.8 22.7502 16.5 22.7502Z",
    fill: "#4E008E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 10.75H5C2.58 10.75 1.25 9.42 1.25 7V5C1.25 2.58 2.58 1.25 5 1.25H19C21.42 1.25 22.75 2.58 22.75 5V7C22.75 9.42 21.42 10.75 19 10.75ZM5 2.75C3.42 2.75 2.75 3.42 2.75 5V7C2.75 8.58 3.42 9.25 5 9.25H19C20.58 9.25 21.25 8.58 21.25 7V5C21.25 3.42 20.58 2.75 19 2.75H5Z",
    fill: "#4E008E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.82 14.75H10.18C9.76999 14.75 9.42999 14.41 9.42999 14C9.42999 13.59 9.76999 13.25 10.18 13.25H13.82C14.23 13.25 14.57 13.59 14.57 14C14.57 14.41 14.23 14.75 13.82 14.75Z",
    fill: "#4E008E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveProduct);
export default __webpack_public_path__ + "static/media/archive-product.8bf89f9a226d5d0cc95fb90c16f1c3bd.svg";
export { ForwardRef as ReactComponent };